import { utils, anodum } from '@yola/ws-sdk';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function waitWsBlocksLoading(targetDocument, onSuccess, onFail = () => {}) {
  const wsBlocksNodes = [...targetDocument.querySelectorAll('ws-block[src]')];
  // comparison with `false` in order to avoid the case when imported site
  // may have `ws-block` which is different from our ws-block component
  const nonReadyBlocks = wsBlocksNodes.filter((wsBlock) => wsBlock.ready === false);

  if (!nonReadyBlocks.length) {
    onSuccess();
    return;
  }

  const blockLoadingQue = nonReadyBlocks.map(
    (wsBlock) =>
      new Promise((resolve, reject) => {
        function onReady() {
          resolve();

          // eslint-disable-next-line
          wsBlock.removeEventListener('error', onError);
        }

        function onError() {
          reject();

          wsBlock.removeEventListener('ready', onReady);
        }

        wsBlock.addEventListener('ready', onReady, { once: true });
        wsBlock.addEventListener('error', onError, { once: true });
      })
  );

  Promise.all(blockLoadingQue).then(onSuccess, onFail);
}

class Frame extends React.Component {
  componentDidMount() {
    const { iframe } = this;
    const { onBeforeLoad } = this.props;

    onBeforeLoad(iframe);
  }

  getDoctypeAsString() {
    const { src } = this.props;
    if (!src.doctype) return '';
    return anodum.serializeDocumentType(src);
  }

  handleFrameLoad = () => {
    const { src, onLoad, onDocumentFetch, onDocumentReady } = this.props;
    const isDocumentObject = src && typeof src !== 'string';

    if (isDocumentObject) {
      const { document } = this.iframe.contentWindow;
      onDocumentFetch(document);
      waitWsBlocksLoading(
        document,
        () => {
          onDocumentReady(document);
          onLoad(this.iframe);
        },
        () => {
          onDocumentReady(document);
          onLoad(this.iframe);
        }
      );
    } else {
      onLoad(this.iframe);
    }
  };

  render() {
    const { id, src, className, sandbox } = this.props;
    const isDocumentObject = src && typeof src !== 'string';
    const srcLink = typeof src === 'string' ? src : undefined;
    const srcDoc = isDocumentObject
      ? this.getDoctypeAsString() + src.documentElement.outerHTML
      : undefined;
    const frameClass = classNames('ws-syncy-frame-window', className);

    return (
      <iframe
        id={id}
        title={id}
        name="syncy-frame"
        src={srcLink}
        srcDoc={srcDoc}
        ref={(iframe) => {
          this.iframe = iframe;
        }}
        className={frameClass}
        allowFullScreen
        onLoad={this.handleFrameLoad}
        sandbox={sandbox}
        translate="no"
      />
    );
  }
}

Frame.defaultProps = {
  id: 'syncy-frame-instance',
  className: null,
  onBeforeLoad: utils.noop,
  onLoad: utils.noop,
  onDocumentFetch: utils.noop,
  onDocumentReady: utils.noop,
  sandbox:
    'allow-scripts allow-forms allow-same-origin allow-popups allow-pointer-lock allow-presentation',
};

Frame.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onBeforeLoad: PropTypes.func,
  onLoad: PropTypes.func,
  onDocumentFetch: PropTypes.func,
  onDocumentReady: PropTypes.func,
  sandbox: PropTypes.string,
};

export default Frame;
